import type { IReactionDisposer } from 'mobx';
import { reaction } from 'mobx';
import { useEffect, useState } from 'react';
import type { IBaseViewModel } from '@/engine/app/interfaces';

export const useGroupItemsVisibleState = (
  itemVMs: Array<IBaseViewModel> | undefined
): { visibilityState: boolean | 'mixed' } => {
  const [visibilityState, setVisibilityState] = useState<boolean | 'mixed'>(false);

  useEffect(() => {
    const updateVisibiliyState = (viewModels?: Array<IBaseViewModel>): void => {
      if (!viewModels) {
        setVisibilityState(false);
        return;
      }
      const isEveryItemVisible: boolean = viewModels.every((item) => item.isVisible);
      const isEveryItemNotVisible: boolean = viewModels.every((item) => !item.isVisible);

      if (isEveryItemVisible) {
        setVisibilityState(true);
      } else if (isEveryItemNotVisible) {
        setVisibilityState(false);
      } else {
        setVisibilityState('mixed');
      }
    };
    const disposers: Array<IReactionDisposer> = [];
    if (itemVMs) {
      itemVMs.forEach((viewModel) => {
        disposers.push(
          reaction(
            () => viewModel.isVisible,
            () => updateVisibiliyState(itemVMs)
          )
        );
      });
    }
    updateVisibiliyState(itemVMs);
    return (): void => {
      disposers.forEach((disposer) => disposer());
    };
  }, [itemVMs]);

  return { visibilityState };
};
